import React, { useEffect, useState } from "react";
import { isInTable } from "@tiptap/pm/tables";
import { InsertTableModal } from "./insert-table-modal";

export const TablePlugin = ({ editor }) => {
    const [open, setOpen] = useState(false);
    const [isNestedTable, setIsNestedTable] = useState(false);

    const showInsertTable = () => {
        // Check if cursor is inside a table - if so, the new table will be nested
        const isNested = editor ? isInTable(editor.state) : false;
        setIsNestedTable(isNested);
        setOpen(true);
    };

    const onInsert = (values) => {
        editor.chain().focus().insertTable(values).run();
        setOpen(false);
    };

    useEffect(() => {
        if (!editor) {
            return;
        }

        editor.on("showInsertTable", showInsertTable);

        return () => editor.off("showInsertTable", showInsertTable);
    }, [editor]);

    return (
        <>
            {open && (
                <InsertTableModal
                    open={true}
                    onInsert={onInsert}
                    onClose={() => setOpen(false)}
                    isNestedTable={isNestedTable}
                />
            )}
        </>
    );
};

export default TablePlugin;
